var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.396849 0.0653329C0.118977 0.40908 -0.0215432 0.849015 0.00384147 1.29574V20.7023C-0.0201068 21.1488 0.120245 21.5882 0.396849 21.9327L0.46116 21.999L11.0009 11.1243V10.8664L0.46116 -0.000976562L0.396849 0.0653329Z",
    fill: "url(#paint0_linear_8444_27647)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6566 14.999L11.0009 11.1326V10.8576L14.6566 6.99902L14.7384 7.04618L19.0703 9.64735C20.3111 10.3861 20.3111 11.6041 19.0703 12.3507L14.7384 14.9519L14.6566 14.999Z",
    fill: "url(#paint1_linear_8444_27647)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0009 14.602L11.2264 10.999L0.000915527 21.6711C0.259662 21.8741 0.581804 21.9893 0.916633 21.9984C1.25146 22.0076 1.57997 21.9102 1.85044 21.7215L14.9783 14.602",
    fill: "url(#paint2_linear_8444_27647)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0009 7.38739L1.85044 0.286181C1.58287 0.0905223 1.25218 -0.0107144 0.914858 -0.000237906C0.577532 0.0102386 0.254494 0.131778 0.000915527 0.343623L11.2037 10.999L15.0009 7.38739Z",
    fill: "url(#paint3_linear_8444_27647)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8444_27647",
    x1: 10.072,
    y1: 1.08945,
    x2: -4.64918,
    y2: 15.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8444_27647",
    x1: 19.2189,
    y1: 10.999,
    x2: -2.19537,
    y2: 10.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8444_27647",
    x1: 12.94,
    y1: 12.9446,
    x2: -6.56709,
    y2: 33.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8444_27647",
    x1: -2.82244,
    y1: -5.9534,
    x2: 5.86223,
    y2: 3.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.a1cd6b27f14c879f0252d72fadb4d960.svg";
export { ForwardRef as ReactComponent };